import React from "react";
import { Helmet } from "react-helmet";

const SchemaLocalBusiness = ({ image, seoSiteUrl, description }) => {
  const imageWidth = image.dimensions ? image.dimensions.width : image.width;
  const imageHeight = image.dimensions ? image.dimensions.height : image.height;

  return (
    <Helmet>
      <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "IMS - Individual Mortgage Solutions",
          "image": "https://ims-fc.cdn.prismic.io/ims-fc/148cfa49-9e27-476a-978a-884a81e01a73_ims-logo-blue.svg?ixlib=gatsbyFP&auto=compress&q=90",
          "url": "https://ims-fc.gr",
          "address": [
            {
              "@type": "PostalAddress",
              "streetAddress": "240, Andrea Syggrou Ave",
              "addressLocality": "Athens",
              "postalCode": "17672",
              "addressCountry": "GR"
            },
            {
              "@type": "PostalAddress",
              "streetAddress": "1, Adrianoupoleos str",
              "addressLocality": "Thessaloniki",
              "postalCode": "55133",
              "addressCountry": "GR"
            },
            {
              "@type": "PostalAddress",
              "streetAddress": "39 Grigoriou Lampraki str",
              "addressLocality": "Rhodes",
              "postalCode": "85100",
              "addressCountry": "GR"
            }
          ],
          "telephone": [
            "+302109520047",
            "+302109520048",
            "+302109513111",
            "+302109583331",
            "+302316018060",
            "+302316018061",
            "+302241021649"
          ],
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 37.9510306,
            "longitude": 23.7087223
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Monday",
              "opens": "09:00",
              "closes": "17:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Tuesday",
              "opens": "09:00",
              "closes": "17:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Wednesday",
              "opens": "09:00",
              "closes": "17:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Thursday",
              "opens": "09:00",
              "closes": "17:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Friday",
              "opens": "09:00",
              "closes": "17:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "00:00",
              "closes": "00:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Sunday",
              "opens": "00:00",
              "closes": "00:00"
            }
          ]
        }
      `}</script>
    </Helmet>
  );
};

export default SchemaLocalBusiness;
